/** @format */

import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import '../css/Terms.css';

const TermsConditions = () => {
	const file_name = 'terms-condicions.md';
	const [markdown, setMarkdown] = useState('');

	useEffect(() => {
		import(`../utils/${file_name}`)
			.then((res) => {
				fetch(res.default)
					.then((res) => res.text())
					.then((text) => {
						setMarkdown(text);
					});
			})
			.catch((err) => {
				console.log(err);
			});
	});

	return (
		<div className='terms-conditions'>
			<div className='terms-conditions-container container padding'>
				<Markdown>{markdown}</Markdown>
			</div>
		</div>
	);
};

export default TermsConditions;
